/* @ngInject */

export default (
  $rootScope,
  helperService,
  helperPdfService,
  Address,
  OwnershipType,
  PropertyType,
  ZoningOption
) => {
  /**
   * Create sub-header.
   *
   * @param {Array} homeLoanSecurities
   * @param {Array} contacts
   *
   * @returns {Object}
   */
  const prepareHomeLoanSecuritiesDetails = ({ homeLoanSecurities, contacts }) => {
    const content = [];
    if (homeLoanSecurities?.securitySplits?.length) {
      if (helperService.getOrganizationCountry().cca2 === 'NZ') {
        content.push({
          text: '',
          margin: [0, 20, 0, 0]
        });
      }
      content.push(
        helperPdfService.createHeader({
          title: 'SECURITY',
          pageBreak: helperService.getOrganizationCountry().cca2 === 'NZ' ? '' : 'before'
        })
      );
      const len = homeLoanSecurities.securitySplits.length;
      for (let s = 0; s < len; s += 1) {
        content.push(
          helperPdfService.createSubHeader({
            title: `SECURITY #${s + 1} DETAILS`
          })
        );
        const security = homeLoanSecurities.securitySplits[s];
        if (
          security?.ownershipType?.name === OwnershipType.owner_occupied.name &&
          helperService.getOrganizationCountry().cca2 !== 'NZ'
        ) {
          content.push({
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: [
                [
                  {
                    text: [
                      { text: 'Address\n', style: 'label' },
                      {
                        text: Address.getAddress(security?.address),
                        style: 'value'
                      }
                    ],
                    colSpan: 3
                  },
                  '',
                  '',
                  {
                    text: [
                      { text: 'Security value\n', style: 'label' },
                      {
                        text: helperService
                          .isNumber(security?.value, true)
                          .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                        style: 'value'
                      }
                    ]
                  }
                ],
                [
                  {
                    text: [
                      { text: 'Property type\n', style: 'label' },
                      {
                        text:
                          security?.propertyType?.name !== PropertyType.none.name
                            ? security?.propertyType?.title || '-'
                            : '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Zoning\n', style: 'label' },
                      {
                        text:
                          security?.zoning?.name !== ZoningOption.none.name
                            ? security?.zoning?.title || '-'
                            : '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Valuation\n', style: 'label' },
                      {
                        text: security?.valuation
                          ? 'Certified valuation'
                          : 'Applicant estimate',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      {
                        text: 'Ownership type\n',
                        style: 'label'
                      },
                      {
                        text: 'Owner occupied',
                        style: 'value'
                      }
                    ]
                  }
                ],
                [
                  {
                    text: [
                      {
                        text: 'To be sold\n',
                        style: 'label'
                      },
                      {
                        text: security?.toBeSold ? 'Yes' : 'No',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      {
                        text: 'Set as primary\n',
                        style: 'label'
                      },
                      {
                        text: security?.isPrimary ? 'Yes' : 'No',
                        style: 'value'
                      }
                    ]
                  },
                  '',
                  ''
                ],
                [
                  {
                    text: [
                      {
                        text: 'Ownership\n',
                        style: 'label'
                      },
                      {
                        text: helperService.getOwnerships({
                          contacts,
                          ownership: security.ownership
                        }),
                        style: 'value'
                      }
                    ],
                    colSpan: 4
                  },
                  '',
                  '',
                  ''
                ]
              ]
            },
            layout: 'noBorders'
          });
        }
        if (
          security?.ownershipType?.name === OwnershipType.owner_occupied.name &&
          helperService.getOrganizationCountry().cca2 === 'NZ'
        ) {
          content.push({
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: [
                [
                  {
                    text: [
                      { text: 'Address\n', style: 'label' },
                      {
                        text: Address.getAddress(security?.address),
                        style: 'value'
                      }
                    ],
                    colSpan: 3
                  },
                  '',
                  '',
                  {
                    text: [
                      { text: 'Security value\n', style: 'label' },
                      {
                        text: helperService
                          .isNumber(security?.value, true)
                          .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                        style: 'value'
                      }
                    ]
                  }
                ],
                [
                  {
                    text: [
                      { text: 'Monthly boarder income\n', style: 'label' },
                      {
                        text: helperService
                          .isNumber(security?.monthlyRentalIncome, true)
                          .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Number of boarders\n', style: 'label' },
                      {
                        text: security?.numberOfBoarders,
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'All inclusive\n', style: 'label' },
                      {
                        text: security?.allInclusive ? 'Yes' : 'No',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Property type\n', style: 'label' },
                      {
                        text:
                          security?.propertyType?.name !== PropertyType.none.name
                            ? security?.propertyType?.name || '-'
                            : '-',
                        style: 'value'
                      }
                    ]
                  }
                ],
                [
                  {
                    text: [
                      { text: 'Zoning\n', style: 'label' },
                      {
                        text:
                          security?.zoning?.name !== ZoningOption.none.name
                            ? security?.zoning?.title || '-'
                            : '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Valuation\n', style: 'label' },
                      {
                        text: security?.valuation
                          ? 'Certified valuation'
                          : 'Applicant estimate',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      {
                        text: 'Ownership type\n',
                        style: 'label'
                      },
                      {
                        text: 'Owner occupied',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      {
                        text: 'To be sold\n',
                        style: 'label'
                      },
                      {
                        text: security?.toBeSold ? 'Yes' : 'No',
                        style: 'value'
                      }
                    ]
                  }
                ],
                [
                  {
                    text: [
                      {
                        text: 'Set as primary\n',
                        style: 'label'
                      },
                      {
                        text: security?.isPrimary ? 'Yes' : 'No',
                        style: 'value'
                      }
                    ]
                  },
                  '',
                  '',
                  ''
                ],
                [
                  {
                    text: [
                      {
                        text: 'Ownership\n',
                        style: 'label'
                      },
                      {
                        text: helperService.getOwnerships({
                          contacts,
                          ownership: security.ownership
                        }),
                        style: 'value'
                      }
                    ],
                    colSpan: 4
                  },
                  '',
                  '',
                  ''
                ]
              ]
            },
            layout: 'noBorders'
          });
        }
        if (security?.ownershipType?.name === OwnershipType.investment.name) {
          content.push({
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: [
                [
                  {
                    text: [
                      { text: 'Address\n', style: 'label' },
                      {
                        text: Address.getAddress(security?.address),
                        style: 'value'
                      }
                    ],
                    colSpan: 3
                  },
                  '',
                  '',
                  {
                    text: [
                      { text: 'Security value\n', style: 'label' },
                      {
                        text: helperService
                          .isNumber(security?.value, true)
                          .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                        style: 'value'
                      }
                    ]
                  }
                ],
                [
                  {
                    text: [
                      { text: 'Monthly rental income\n', style: 'label' },
                      {
                        text: helperService
                          .isNumber(security?.monthlyRentalIncome, true)
                          .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Property type\n', style: 'label' },
                      {
                        text:
                          security?.propertyType?.name !== PropertyType.none.name
                            ? security?.propertyType?.name || '-'
                            : '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Zoning\n', style: 'label' },
                      {
                        text:
                          security?.zoning?.name !== ZoningOption.none.name
                            ? security?.zoning?.title || '-'
                            : '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Valuation\n', style: 'label' },
                      {
                        text: security?.valuation
                          ? 'Certified valuation'
                          : 'Applicant estimate',
                        style: 'value'
                      }
                    ]
                  }
                ],
                [
                  {
                    text: [
                      {
                        text: 'Ownership type\n',
                        style: 'label'
                      },
                      {
                        text: 'Investment',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      {
                        text: 'To be sold\n',
                        style: 'label'
                      },
                      {
                        text: security?.toBeSold ? 'Yes' : 'No',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      {
                        text: 'Set as primary\n',
                        style: 'label'
                      },
                      {
                        text: security?.isPrimary ? 'Yes' : 'No',
                        style: 'value'
                      }
                    ]
                  },
                  ''
                ],
                [
                  {
                    text: [
                      {
                        text: 'Ownership\n',
                        style: 'label'
                      },
                      {
                        text: helperService.getOwnerships({
                          contacts,
                          ownership: security.ownership
                        }),
                        style: 'value'
                      }
                    ],
                    colSpan: 4
                  },
                  '',
                  '',
                  ''
                ]
              ]
            },
            layout: 'noBorders'
          });
        }

        // const contactForValuation = homeLoanSecurities.contactsForValuation[s];
        // if (!contactForValuation?.isOther) {
        //   content.push({
        //     table: {
        //       widths: ['16.6%', '16.6%', '16.6%', '16.6%', '16.6%', '16.6%'],
        //       body: [
        //         [
        //           {
        //             text: [
        //               { text: 'Loan party\n', style: 'label' },
        //               {
        //                 text:
        //                   helperService.getContact({
        //                     contacts,
        //                     idContact: contactForValuation?.loanParty
        //                   }) || '-',
        //                 style: 'value'
        //               }
        //             ]
        //           },
        //           '',
        //           '',
        //           '',
        //           '',
        //           ''
        //         ]
        //       ]
        //     },
        //     layout: 'noBorders'
        //   });
        // } else {
        //   content.push({
        //     table: {
        //       widths: ['16.6%', '16.6%', '16.6%', '16.6%', '16.6%', '16.6%'],
        //       body: [
        //         [
        //           {
        //             text: [
        //               { text: 'Other company name\n', style: 'label' },
        //               {
        //                 text: contactForValuation?.other?.companyName || '-',
        //                 style: 'value'
        //               }
        //             ]
        //           },
        //           {
        //             text: [
        //               { text: 'Title\n', style: 'label' },
        //               {
        //                 text: contactForValuation?.other?.title?.name !== PersonalTitle.none.name ? contactForValuation?.other?.title?.title || '-' : '-',
        //                 style: 'value'
        //               }
        //             ]
        //           },
        //           {
        //             text: [
        //               { text: 'Contact person name\n', style: 'label' },
        //               {
        //                 text: contactForValuation?.other?.firstName || '-',
        //                 style: 'value'
        //               }
        //             ]
        //           },
        //           {
        //             text: [
        //               { text: 'Contact surname\n', style: 'label' },
        //               {
        //                 text: contactForValuation?.other?.surname || '-',
        //                 style: 'value'
        //               }
        //             ]
        //           },
        //           {
        //             text: [
        //               { text: 'Phone\n', style: 'label' },
        //               {
        //                 text: `${
        //                   contactForValuation?.other?.phone
        //                     ? contactForValuation?.other?.phoneCode
        //                     : ''
        //                 } ${contactForValuation?.other?.phone || '-'}`,
        //                 style: 'value'
        //               }
        //             ]
        //           },
        //           {
        //             text: [
        //               { text: 'Contact type\n', style: 'label' },
        //               {
        //                 text: helperService.getHomeLoanSecurityContactForValuationType(
        //                   contactForValuation?.other?.type
        //                 ),
        //                 style: 'value'
        //               }
        //             ]
        //           }
        //         ],
        //         [
        //           {
        //             text: [
        //               { text: 'Address\n', style: 'label' },
        //               {
        //                 text: Address.getAddress(contactForValuation?.other?.address),
        //                 style: 'value'
        //               }
        //             ],
        //             colSpan: 3
        //           },
        //           '',
        //           '',
        //           '',
        //           '',
        //           ''
        //         ]
        //       ]
        //     },
        //     layout: 'noBorders'
        //   });
        // }

        // const title = homeLoanSecurities.titleDetails[s];
        // content.push({
        //   table: {
        //     widths: ['16.6%', '16.6%', '16.6%', '16.6%', '16.6%', '16.6%'],
        //     body: [
        //       [
        //         {
        //           text: [
        //             { text: 'Title type\n', style: 'label' },
        //             {
        //               text: helperService.getHomeLoanSecurityTitleType({
        //                 contacts,
        //                 idContact: title?.titleType
        //               }),
        //               style: 'value'
        //             }
        //           ]
        //         },
        //         {
        //           text: [
        //             { text: 'Title\n', style: 'label' },
        //             {
        //               text: helperService.getHomeLoanSecurityTitle({
        //                 contacts,
        //                 idContact: title?.title
        //               }),
        //               style: 'value'
        //             }
        //           ]
        //         },
        //         {
        //           text: [
        //             { text: 'Lot\n', style: 'label' },
        //             {
        //               text: title?.lot || 0,
        //               style: 'value'
        //             }
        //           ]
        //         },
        //         {
        //           text: [
        //             { text: 'Plan\n', style: 'label' },
        //             {
        //               text: title?.plan || '-',
        //               style: 'value'
        //             }
        //           ]
        //         },
        //         {
        //           text: [
        //             { text: 'Volume\n', style: 'label' },
        //             {
        //               text: title?.volume || 0,
        //               style: 'value'
        //             }
        //           ]
        //         },
        //         {
        //           text: [
        //             { text: 'Folio\n', style: 'label' },
        //             {
        //               text: title?.folio || 0,
        //               style: 'value'
        //             }
        //           ]
        //         }
        //       ]
        //     ]
        //   },
        //   layout: 'noBorders'
        // });
      }
    }
    return content;
  };

  return {
    prepareHomeLoanSecuritiesDetails
  };
};
